import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../../services/FormService';
import {Checkbox} from 'primeng/checkbox';
import {Select} from 'primeng/select';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-signature',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox,
    Select
  ],
  template: `
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox [(ngModel)]="field.required_employee_signature" binary="true"/>
        <label>{{ Yii.t('app', 'Required Employee Signature') }}</label>
      </div>
    </div>
    @if (field.required_employee_signature) {
      <div class="form-row flex-align-center">
        <label>{{ Yii.t('app', 'Related "Employee Picker"') }}
          <span class="text-danger">*</span>
        </label>
        <div>
          <p-select
            [options]="getEmployeeOptions()"
            [(ngModel)]="field.related_employee_picker_id"
            optionLabel="field_title"
            optionValue="field_id"
            appendTo="body"
            />
        </div>
      </div>
    }
  `
})
export class FieldSignature {
  Yii = Yii;
  @Input() field: any;

  constructor(public fsvc: FormService) {
  }

  public getEmployeeOptions(): any[] {
    return this.fsvc.form?.form_fields?.filter(
      (field: any) => field.field_type === 'employees' && field.add_as_approver === '1'
    ).map(
      (f:any) => {
        const ff = {...f}
        ff.field_title = f.field_title.trim() !== '' ? f.field_title : 'Field-' + (f.field_id + 1)
        return ff;
      }
    ) ?? [];
  }

  onSignatureRequirementChange(): void {
    if (this.field.required_employee_signature) {
      this.field.field_required = false;
    }
    this.field.related_employee_picker_id = '';
  }
}
